import { useEffect } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { router } from './routes'
import { LoginPage } from './features/auth/LoginPage'
import { useAuth } from './store/auth'

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: 1 } },
})

export default function App() {
  const status = useAuth((s) => s.status)
  const restore = useAuth((s) => s.restore)

  useEffect(() => {
    restore()
  }, [restore])

  return (
    <QueryClientProvider client={queryClient}>
      {status === 'loading' ? (
        <div className="flex h-dvh items-center justify-center bg-ink-50">
          <Loader2 className="h-5 w-5 animate-spin text-ink-400" />
        </div>
      ) : status === 'anon' ? (
        <LoginPage />
      ) : (
        <RouterProvider router={router} />
      )}
    </QueryClientProvider>
  )
}
